export const category = {
    colordiamondcategory: {
        "id": 100001,
        "url": "/coloreddiamond",
        "name": "Colored Diamonds",
        "image": null,
        "url_key": "coloreddiamond",
        "url_path": "coloreddiamond",
        "is_active": true,
        "meta_title": null,
        "description": null,
        "canonical_url": "coloreddiamond",
        "product_count": 1,
        "meta_keywords": null,
        "default_sort_by": null,
        "meta_description": null,
        "landing_page": null,
        "display_mode": "PRODUCTS",
        "is_anchor": 1,
        "most_popular_banner": null,
        "cms_block": null,
        "breadcrumbs": [
            {
                "category_name": "Colored Diamonds",
                "category_level": 2,
                "category_url": "/coloreddiamond",
                "category_is_active": true
            }
        ],
        "children": []
    },
};